/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceComplianceStatusParams,
  GetMaintenanceComplianceStatusParams,
  MaintenanceComplianceStatus,
  MaintenanceComplianceStatusInsertPayload,
  MaintenanceComplianceStatusUpdate,
  PatchMaintenanceComplianceStatusParams,
  PostMaintenanceComplianceStatusParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceComplianceStatusResponse200 = {
  data: MaintenanceComplianceStatus[]
  status: 200
}

export type getMaintenanceComplianceStatusResponse206 = {
  data: MaintenanceComplianceStatus[]
  status: 206
}

export type getMaintenanceComplianceStatusResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceComplianceStatusResponseSuccess = (getMaintenanceComplianceStatusResponse200 | getMaintenanceComplianceStatusResponse206) & {
  headers: Headers;
};
export type getMaintenanceComplianceStatusResponseError = (getMaintenanceComplianceStatusResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceComplianceStatusResponse = (getMaintenanceComplianceStatusResponseSuccess | getMaintenanceComplianceStatusResponseError)

export const getGetMaintenanceComplianceStatusUrl = (params?: GetMaintenanceComplianceStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_compliance_status?${stringifiedParams}` : `${backendBaseUrl}/maintenance_compliance_status`
}

/**
 * @summary Read rows from `maintenance_compliance_status`.
 */
export const getMaintenanceComplianceStatus = async (params?: GetMaintenanceComplianceStatusParams, options?: RequestInit): Promise<getMaintenanceComplianceStatusResponse> => {

  const res = await fetch(getGetMaintenanceComplianceStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceComplianceStatusResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceComplianceStatusResponse
}


export type postMaintenanceComplianceStatusResponse201 = {
  data: MaintenanceComplianceStatus[]
  status: 201
}

export type postMaintenanceComplianceStatusResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceComplianceStatusResponseSuccess = (postMaintenanceComplianceStatusResponse201) & {
  headers: Headers;
};
export type postMaintenanceComplianceStatusResponseError = (postMaintenanceComplianceStatusResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceComplianceStatusResponse = (postMaintenanceComplianceStatusResponseSuccess | postMaintenanceComplianceStatusResponseError)

export const getPostMaintenanceComplianceStatusUrl = (params?: PostMaintenanceComplianceStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_compliance_status?${stringifiedParams}` : `${backendBaseUrl}/maintenance_compliance_status`
}

/**
 * @summary Insert one or more rows into `maintenance_compliance_status`.
 */
export const postMaintenanceComplianceStatus = async (maintenanceComplianceStatusInsertPayload: MaintenanceComplianceStatusInsertPayload,
    params?: PostMaintenanceComplianceStatusParams, options?: RequestInit): Promise<postMaintenanceComplianceStatusResponse> => {

  const res = await fetch(getPostMaintenanceComplianceStatusUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceComplianceStatusInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceComplianceStatusResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceComplianceStatusResponse
}


export type patchMaintenanceComplianceStatusResponse200 = {
  data: MaintenanceComplianceStatus[]
  status: 200
}

export type patchMaintenanceComplianceStatusResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceComplianceStatusResponseSuccess = (patchMaintenanceComplianceStatusResponse200) & {
  headers: Headers;
};
export type patchMaintenanceComplianceStatusResponseError = (patchMaintenanceComplianceStatusResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceComplianceStatusResponse = (patchMaintenanceComplianceStatusResponseSuccess | patchMaintenanceComplianceStatusResponseError)

export const getPatchMaintenanceComplianceStatusUrl = (params?: PatchMaintenanceComplianceStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_compliance_status?${stringifiedParams}` : `${backendBaseUrl}/maintenance_compliance_status`
}

/**
 * @summary Update the rows of `maintenance_compliance_status` matching the given filters.
 */
export const patchMaintenanceComplianceStatus = async (maintenanceComplianceStatusUpdate: MaintenanceComplianceStatusUpdate,
    params?: PatchMaintenanceComplianceStatusParams, options?: RequestInit): Promise<patchMaintenanceComplianceStatusResponse> => {

  const res = await fetch(getPatchMaintenanceComplianceStatusUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceComplianceStatusUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceComplianceStatusResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceComplianceStatusResponse
}


export type deleteMaintenanceComplianceStatusResponse200 = {
  data: MaintenanceComplianceStatus[]
  status: 200
}

export type deleteMaintenanceComplianceStatusResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceComplianceStatusResponseSuccess = (deleteMaintenanceComplianceStatusResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceComplianceStatusResponseError = (deleteMaintenanceComplianceStatusResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceComplianceStatusResponse = (deleteMaintenanceComplianceStatusResponseSuccess | deleteMaintenanceComplianceStatusResponseError)

export const getDeleteMaintenanceComplianceStatusUrl = (params?: DeleteMaintenanceComplianceStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_compliance_status?${stringifiedParams}` : `${backendBaseUrl}/maintenance_compliance_status`
}

/**
 * @summary Delete the rows of `maintenance_compliance_status` matching the given filters.
 */
export const deleteMaintenanceComplianceStatus = async (params?: DeleteMaintenanceComplianceStatusParams, options?: RequestInit): Promise<deleteMaintenanceComplianceStatusResponse> => {

  const res = await fetch(getDeleteMaintenanceComplianceStatusUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceComplianceStatusResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceComplianceStatusResponse
}


